/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import ValueColumn from "./ValueColumn";
import {RowCell} from "../../atoms/layout/RowCell";
import {QuantityInput} from "../../atoms/forms/QuantityInput";
import {AddToCartButton} from "../../atoms/bootstrap/Button";
import * as React from "react";
import {useI18N} from "../../hoc/withI18N";
import * as PropTypes from "prop-types";

const sizes = { sm: 3, xxs: 6, xs: 6 };
const altSizes = { xxs: 12, sm: 3 };

export function BundleDetailColumn({ bundle, addToCart, quantity, updateQuantity, isLoading: disabled, response, addedQuantity = 0}) {

    const translate = useI18N();

    if (!bundle) {
        return null;
    }

    const remainingQuantity = (bundle.remainingQuantity || 0) - addedQuantity;

    return <React.Fragment>
        <ValueColumn sizes={sizes} label={translate("Unit price")} value={bundle.unitPrice}
                     altValue={bundle.promotionUnitPrice}/>
        <RowCell sizes={sizes} className={"table-group-cell__input"}>
            <QuantityInput min={1} max={remainingQuantity} disabled={disabled || remainingQuantity === 0}
                           updateValue={updateQuantity} value={quantity}/>
        </RowCell>
        {addToCart && <RowCell sizes={altSizes} className={"is-last p-align-self-center-sm"}>
            <AddToCartButton loading={disabled} disabled={!remainingQuantity || disabled} block onClick={addToCart} response={response}/>
        </RowCell>}
    </React.Fragment>
}


BundleDetailColumn.propTypes = {
    price: PropTypes.string,
    altPrice: PropTypes.string,
    quantity: PropTypes.number,
    addToCart: PropTypes.func,
    columns: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};

BundleDetailColumn.defaultProps = {
    quantity: 0
};
